import { BLOCKS } from '@contentful/rich-text-types'
import style from '../../styles/components/need2know/need2know'

const renderOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <>
        <div className='text'>{children}</div>
        <style jsx>{style}</style>
      </>
    )
  }
}

export default renderOptions
